var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1437,
    height: 899,
    viewBox: "0 0 1437 899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1435.19 897.664C1406.25 814.836 1320.49 761.952 1233.7 749.081C1146.9 736.21 1058.77 756.859 974.733 782.06C890.694 807.262 807.034 837.411 719.565 844.342C632.097 851.274 537.857 831.544 475.663 769.642C432.891 727.046 405.895 665.888 351.275 640.161C301.849 616.9 244.018 629.435 190.229 638.891C136.441 648.347 74.9469 652.302 33.3431 617.002C-8.88815 581.148 -7.30859 478.658 25.1914 441.158C78.1914 391.658 48.739 323.095 94.6914 292.158C140.644 261.222 168.691 254.449 232.191 231.658C306.025 205.158 327.97 158.675 323.811 103.441C319.652 48.2078 270.387 -4.7199 215.358 1.68629",
    stroke: "#FDB9BB",
    strokeWidth: 2.37861,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "4.98 9.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d3d278b76939a458a6abcd549392c8bb.svg";
export { ForwardRef as ReactComponent };